export default __webpack_public_path__ + "static/javascript-d4e709c36c294d8238e7ffd59403935a.svg";